<script lang="ts">
	import { slideIn } from '$lib/actions/slideIn';
	import Quote from '$lib/icons/quote.svelte';
	import Image from '$lib/storyblok/components/image.svelte';
	import { editable } from '$lib/storyblok/editable';
	import type { SbImage, SbLink } from '$lib/storyblok/types';
	import { getSbUrl } from '$lib/utils/storyblok/url';
	import type { ISbStoryData } from '@storyblok/js';
	import type { CardCategory } from './types';

	interface Props {
		content: ISbStoryData<{
			cover_image: SbImage;
			quote: string;
			link: SbLink;
			category: CardCategory;
		}>['content'];
		delay?: number;
		threshold?: number;
	}

	let { content, delay = 500, threshold = 0.3 }: Props = $props();
</script>

<a
	use:editable={content}
	use:slideIn={{ delay, threshold }}
	href={getSbUrl(content.link)}
	target={content.link?.target}
	class="relative block overflow-hidden rounded-xl p-3 opacity-[0.01] lg:p-4"
>
	<div class="absolute inset-0">
		<Image
			src={content.cover_image?.filename}
			alt={content.cover_image?.alt}
			title={content.cover_image?.title}
			class="h-full w-full scale-x-125 transform-gpu opacity-80 blur-[30px]"
			height={420}
			sizes={{ 1024: { height: 640 } }}
		/>
		<div class="absolute inset-0 bg-black/45"></div>
	</div>

	<div class="relative flex flex-col gap-y-3 lg:gap-y-4">
		<Image
			src={content.cover_image?.filename}
			alt={content.cover_image?.alt}
			title={content.cover_image?.title}
			class="aspect-square w-full rounded-lg"
			height={420}
			sizes={{ 1024: { height: 640 } }}
		/>

		<div class="text-white">
			<Quote class="mb-2 h-3 w-3" />
			<p class="text-[16px]/[140%] tracking-[-.16px] lg:text-[20px]/[140%] lg:tracking-[-.2px]">
				{content.quote}
			</p>
		</div>
	</div>
</a>

<style>
	a {
		box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.02);
	}
</style>
